import { Injectable } from '@angular/core';
import { IResponseMeta, RequestService } from '@df/api/request/request.service';
import { App } from '@df/core/app';
import { DfEventService } from '@df/core/service/df-event';
import { Customer as CustomerInterfaces } from '@df/session/customer/customer.interfaces';

@Injectable({
    providedIn: 'root'
})
export class Customer {
    /**
     * Buffer for the last response with customer data
     * so we can intantiate serviceas after customer is loaded
     */
    private lastResponseContent: any;
    /**
     * Customer assets info
     */
    private assets: CustomerInterfaces.IProviderAsset[] = [];

    /**
     * That is after all customer data and internal promises are ready
     */
    isLoaded = false;

    constructor(app: App, requestService: RequestService, dfEventsService: DfEventService) {
        app.customer = <Customer>this;

        // subscribe to BE data
        dfEventsService.success(async event => {
            if (event.id == 'dfApiRequest') {
                // check if we've send email, if so we will record that customer email is known
                const email = event.data.requestData?.email;
                if (email) {
                    this['model'].setSeenEmail(email);
                }

                const customerData = event.result?.customer;
                if (customerData) {
                    if (customerData.general) {
                        this.lastResponseContent = customerData;
                    }
                    const promises: Promise<any>[] = [];
                    for (const asset of this.assets) {
                        if (asset.account && customerData.general && !customerData.general.logged) {
                            this[asset.id].setData(undefined);
                        } else if (asset.listener && customerData[asset.listener]) {
                            const promise = this[asset.id].setData(customerData[asset.listener]);
                            if (promise instanceof Promise) {
                                promises.push(promise);
                            }
                        }
                    }
                    if (promises.length) {
                        await Promise.all(promises);
                    }

                    this.isLoaded = true;
                }
            }
        });
    }

    /**
     * Method to add assets (Note that you need to call it before bootstraping)
     * @author Maurycy Ornat maurycy@tomandco.co.uk
     * @param  {Customer.IProviderAsset} asset
     */
    register(asset: CustomerInterfaces.IProviderAsset, instance) {
        this[asset.id] = instance;
        this.assets.push(asset);

        // initiate with last customer data
        if (asset.listener && this.lastResponseContent && this.lastResponseContent[asset.listener]) {
            this[asset.id].setData(this.lastResponseContent[asset.listener]);
        }
    }
}

/**
 * Register service in app.
 */
declare module '@df/core/app' {
    interface App {
        customer: Customer;
    }
}
